import React from "react";

export default function HelpBlockInput({ ...props }) {
    return (
        <small className="input-help-block form-text text-muted">{ props.text }</small>
    )
}
